import { Vector2, Color } from 'three'

export const updateMaterialFromJSON = async (
  mesh,
  scene_meshes,
  material,
  materialData = {},
  loadedTextures = {},
) => {
  // defaults
  const {
    color: baseColor = '#ffffff',
    roughness: baseRoughness = 1.0,
    normalScale: baseNormalScale = 1.0,
    metalness: baseMetalness = 0.0,
    transparent: transparentFlag = 0,
    sheen: baseSheen = 0.0,
    sheenColor: baseSheenColor = '#000000',
    sheenRoughness: baseSheenRoughness = 1.0,
    thickness: baseThickness = 0.0,
    transmission: baseTransmission = 0.0,
  } = materialData

  const {
    colorMap = null,
    roughnessMap = null,
    normalMap = null,
    opacityMap = null,
  } = loadedTextures

  // color map, indien aanwezig, material = wit
  const color = new Color()
  material.color = colorMap ? color.set('white') : color.set(baseColor)
  material.map = colorMap

  // roughness
  material.roughness = roughnessMap ? 1.0 : baseRoughness
  material.roughnessMap = roughnessMap

  // normal
  material.normalMap = normalMap
  material.normalScale = new Vector2(baseNormalScale, baseNormalScale)

  // metalness / transmission / thickness
  material.metalness = baseMetalness
  material.transmission = baseTransmission
  material.thickness = baseThickness

  // transparency
  material.alphaMap = opacityMap ?? null
  material.transparent = transparentFlag === 1 || transparentFlag === true

  // sheen
  material.sheen = baseSheen
  material.sheenColor = new Color().set(baseSheenColor)
  material.sheenRoughness = baseSheenRoughness

  // three.js vragen om te hercompileren
  material.needsUpdate = true

  // rubber feet mesh hetzelfde materiaal geven
  if (
    scene_meshes &&
    materialData?.attribute &&
    materialData?.color &&
    materialData.attribute === 'frame_material_colour'
  ) {
    const model_name = mesh.name.replace(/_frame_material_colour/g, '')

    scene_meshes.forEach((child) => {
      if (
        child.isMesh &&
        child?.material &&
        child.name === `${model_name}_rubber` &&
        materialData?.code.includes('aluminium')
      ) {
        // mesh gevonden voor frame_material_colour en een overeenkomstige rubber mesh
        child.material.color = new Color().set(materialData.color)
        child.material.needsUpdate = true
        console.log(
          `🖌️ rubber feet found for ${materialData.attribute}, color of ${materialData.code} applied: ${materialData.color}`,
        )
      }
    })
  }
}

export const applyMaterial = async (
  mesh,
  scene_meshes,
  material,
  materialData,
  textures,
  onError,
  onDone,
) => {
  try {
    await updateMaterialFromJSON(
      mesh,
      scene_meshes,
      material,
      materialData,
      textures,
    )
    onDone?.()
  } catch (error) {
    console.error('❌ Error applying material:', error)
    onError?.(error)
  }
}
